<div
  class="ufi"
  [class.ufi--rejected]="item.status === 'REJECTED'"
  [class.ufi--approved]="item.status === 'APPROVED'"
  [class.ufi--submitted]="item.status === 'SUBMITTED'"
>
  <div class="ufi__header">
    <label class="ufi__label" [attr.for]="'fld_' + (item.id || item.itemId)">
      {{ label }}
    </label>
    <span
      class="ufi__chip"
      [style.background]="statusColor(item.status) + '22'"
      [style.color]="statusColor(item.status)"
      [style.border-color]="statusColor(item.status) + '55'"
    >
      {{ statusLabel(item.status) }}
    </span>
  </div>

  <!-- ─── Vista read-only (APPROVED / SUBMITTED) ─── -->
  <ng-container *ngIf="isReadOnly && !control">
    <div class="ufi__readonly-value">
      {{ displayValueForReadOnly }}
    </div>
    <small *ngIf="item.status === 'SUBMITTED'" class="ufi__hint">
      <mat-icon>hourglass_empty</mat-icon>
      Estamos revisando este dato. No necesitás hacer nada.
    </small>
    <small *ngIf="item.status === 'APPROVED'" class="ufi__hint ufi__hint--ok">
      <mat-icon>check_circle</mat-icon>
      ¡Listo! Este dato ya fue validado.
    </small>
  </ng-container>

  <!-- ─── Vista editable (PENDING / REJECTED) ─── -->
  <ng-container *ngIf="control">
    <small *ngIf="currentValueLabel" class="ufi__current">
      Valor actual: {{ currentValueLabel }}
    </small>

    <!-- Boolean: radio Sí/No -->
    <div *ngIf="item.fieldType === 'boolean'" class="ufi__radio-group">
      <label class="ufi__radio">
        <input
          type="radio"
          [formControl]="control"
          [value]="true"
          [attr.disabled]="isReadOnly ? '' : null"
        />
        <span>Sí</span>
      </label>
      <label class="ufi__radio">
        <input
          type="radio"
          [formControl]="control"
          [value]="false"
          [attr.disabled]="isReadOnly ? '' : null"
        />
        <span>No</span>
      </label>
    </div>

    <!-- Prefijo telefónico: select con banderas (mismo dataset que el
         onboarding). El value guardado es el código (`+56`, `+58`, ...)
         que es lo que espera el backend en `prefijoTelefono`. -->
    <div *ngIf="isPhonePrefixField" class="ufi__phone-prefix">
      <span class="ufi__phone-flag" *ngIf="selectedPhonePrefix">
        <img
          [src]="flagPath(selectedPhonePrefix.flag)"
          [alt]="selectedPhonePrefix.name"
        />
      </span>
      <select
        [id]="'fld_' + (item.id || item.itemId)"
        [formControl]="control"
        [attr.disabled]="isReadOnly ? '' : null"
        class="ufi__input ufi__input--select"
        [class.ufi__input--invalid]="hasRequiredError"
      >
        <option value="" disabled selected hidden>
          Elegí un país
        </option>
        <option *ngFor="let opt of phonePrefixOptions" [value]="opt.code">
          {{ opt.name }} ({{ opt.code }})
        </option>
      </select>
    </div>

    <!-- text / number / date / email (no incluye boolean ni phonePrefix) -->
    <input
      *ngIf="item.fieldType !== 'boolean' && !isPhonePrefixField"
      [type]="inputType"
      [id]="'fld_' + (item.id || item.itemId)"
      [formControl]="control"
      [readonly]="isReadOnly"
      [attr.inputmode]="isPhoneNumberField ? 'numeric' : null"
      [attr.autocomplete]="isPhoneNumberField ? 'tel-national' : null"
      (input)="isPhoneNumberField ? onPhoneNumberInput($event) : null"
      class="ufi__input"
      [class.ufi__input--invalid]="hasRequiredError || hasEmailError"
    />

    <small *ngIf="hasRequiredError" class="ufi__error">
      Este campo es obligatorio.
    </small>
    <small *ngIf="hasEmailError" class="ufi__error">
      Ingresá un correo válido (ejemplo: nombre&#64;dominio.com).
    </small>

    <!-- Aviso de verificación por WhatsApp: sólo para el campo
         `telefono`. Explica al cliente que va a recibir un OTP antes
         de que se envíe el número a compliance. -->
    <small *ngIf="isPhoneNumberField" class="ufi__hint ufi__hint--whatsapp">
      <mat-icon>chat</mat-icon>
      Vas a recibir un código por WhatsApp para verificar este número
      antes de enviarlo.
    </small>
  </ng-container>

  <!-- ─── Motivo del rechazo ─── -->
  <small *ngIf="item.status === 'REJECTED' && item.rejectReason" class="ufi__reject">
    <mat-icon>info</mat-icon>
    {{ item.rejectReason }}
  </small>
</div>
